import React from "react";
import { ContentSection } from "sprint-common-web";

import {
    ensureAudioFileRecordDetails,
    FileRecordDetails
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { AudioFileRecordTechnicalView } from "../../../../../../common/file-record-details/technical/AudioFileRecordTechnicalView";

interface AudioFileRecordTechnicalSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const AudioFileRecordTechnicalSection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: AudioFileRecordTechnicalSectionProps): JSX.Element => {
    ensureAudioFileRecordDetails(fileRecordDetails);

    return (
        <ContentSection header="File record technical" isLoading={isFileRecordDetailsLoading} style={{ height: 300 }}>
            <AudioFileRecordTechnicalView fileRecordDetails={fileRecordDetails} />
        </ContentSection>
    );
};
